$shm_showcase_demo_list_page $shm_list_page
	title \Список
	add <= add_handler null
	body <= rows /$mol_view
	items? /string
		\Документы
		\Изображения
		\Заметки
	Row* $mol_paragraph
		title <= row_title* \
